module.exports = __webpack_public_path__ + "static/media/rigid-infrastructure.d434b24b.svg";